import { useState } from 'react';
import './VideoDownload.css'
import Modal from '../Modal'
import fileDownload from 'js-file-download'
import { saveAs } from 'file-saver';

function VideoDownload({ navigation }) {
    const queryString = window.location.search; //URL
    const videoId = queryString.replace("?v=", "")
    const [modalVisibility, setModalVisibility] = useState(false)
    const [isSafari, setSafari] = useState(false)

    const downloadVideo = async () => {
        // const userAgent = navigator.userAgent;
        // const isSafari = userAgent.match(/safari/i)
        // console.log(isSafari);
        // setSafari(isSafari)
        //Make the request
        let response = await fetch(`https://olhaissomeu.com.br/download/`+videoId, {
            method: 'GET',
            headers: {
                'Access-Control-Allow-Origin': '*',
            }
        })
        if(response.status === 200) {
            // Open another URL with the file
            // var newWindow = window.open()
            // let video = await response.blob()
            // if (!newWindow) throw new Error('Window could not be opened.')
            // newWindow.location = URL.createObjectURL(video)
            
            // Download the binary with this
            let video = await response.blob()
            console.log(video);
            fileDownload(video, "olhaissomeu.mp4")

            // Download with file saver
            // saveAs(video, 'olhaissomeu.mp4')
        }
    }

    return (
        <>
            <main className="video-area">
                <video className="video-player" controls autoPlay loop muted src={`https://olhaissomeu.com.br/stream/${videoId}`}>
                    Mensagem de falta de suporte a video
                </video>
            </main>
            <div className='button-area'>
                <button className="download-button" onClick={downloadVideo}>Download</button>
            </div>

            {modalVisibility 
                && 
            <Modal 
                title="Opss" 
                closeModal={() => setModalVisibility(false)}
                content="Estamos trabalhando em melhorias, tente abrir este link em outro navegador (chrome, opera, etc)."
                buttonPrhase="FECHAR"
            />}
        </>
    )
}

export default VideoDownload;